// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"379779cc","239":"d1d1ff10","453":"32c059f1","732":"06e7dcb0"}[chunkId] + ".chunk.js";
};